import gql from 'graphql-tag'
import { EnumFields } from '..'

export const MaritalStatusFragment = gql`
  fragment MaritalStatus on persons_marital_status{
    ${EnumFields}
  }
`
